import BranchTelephonyImg from "public/cxPhoneSystem/branch_office_telephony.png";
import Hybridinfra from "public/cxPhoneSystem/Hybrid_Infrastructure.png";
import CrmCcImg from "public/cxPhoneSystem/CRM_and_CC.png";
import MobWfImg from "public/cxPhoneSystem/mobile_Enable_Workforce.png";

export const APPLICATIONS_CONSTANTS = {
  heading: "Real-World Applications of 3CX VoIP Telephony ",
  description:
    "We handle the complexity so you can focus on delivering a seamless communication experience.",
  applications: [
    {
      image: BranchTelephonyImg,
      title: "Branch Office Telephony",
      content:
        "Simplify voice setup across locations with central 3CX management and SIP trunks.",
      bgcolor: "#F5F4F3",
    },
    {
      image: Hybridinfra,
      title: "Hybrid Infrastructure",
      content:
        "Maintain legacy line support using VoIP gateways while moving to a modern 3CX solution.",
      bgcolor: "#9AC3C9",
    },
    {
      image: CrmCcImg,
      title: "CRM & CC Integration",
      content:
        "Connect 3CX to CRM tools for unified communications and client interaction history.",
      bgcolor: "#B6D8E3",
    },
    {
      image: MobWfImg,
      title: "Mobile-Enabled Workforce",
      content: "Let teams take their extensions anywhere with full-featured 3CX apps.",
      bgcolor: "#93C1C3",
    },
  ],
};
